export default "Lorem ipsum dolor sit amet, iudico atomorum in nec, erat choro eum et. Ex recusabo perpetua torquatos cum. Tractatos elaboraret ea cum. Vim ei wisi ornatus similique, altera phaedrum elaboraret ne vis, iusto prompta vituperata ad eos. Ad quot abhorreant inciderint has.";



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/0/info.js